import { useEffect, useState } from "react";
import "./ResponseDetailsContact.css";
import { FormResponseExtended, Question } from "effno-core";
import { Response } from "effno-core";
import { ContactResponse } from "../config/responseSettings";
import { Contact } from "../shared/Contact";

type ResponseDetailContactProps = {
    question: Question | null;
    responses: FormResponseExtended[] | null;
}


export const ResponseDetailsContact = ({question, responses} : ResponseDetailContactProps) => {

    const exampleResponses : ContactResponse[] = [];
    let emptyResponses  = 0;
    let responsesCount = 0;
   
    if (responses) {
        responses.forEach((formResponse: FormResponseExtended)  => {
            formResponse.responses.forEach((response: Response) => {
                if (response.questionId === question?.id) {
                    responsesCount++;
                    const responseValues = JSON.parse(response.responseValues);

                    console.log("[ResponseDetailsContact] responseValue: ", responseValues);

                    if (!responseValues.firstName) {
                        emptyResponses++;
                    } else {
                        if (exampleResponses.length < 10) {
                            exampleResponses.push({
                                firstName: responseValues.firstName,
                                lastName: responseValues.lastName,
                                phone: responseValues.phone,
                                email: responseValues.email,
                                company: responseValues.company
                            } as ContactResponse);
                        }
                    }
                    
                }

            })
        });
    }

    return (
        <div className="response-details-contact">

            <div className="response-details-generic-header">
                <div className="response-details-generic-stat">
                    Responses: {responsesCount}
                </div>
                <div className="response-details-generic-stat">
                    Empty Responses: {emptyResponses} ({
                        responses?.length ? 
                            Math.floor(emptyResponses / responsesCount * 100) : 
                            0
                        }%)
                </div>
                <p/>
                
            </div>

            {/* <div className="response-details-contact-header">
                Responses: {responsesCount}
                <p/>
                Empty Responses: {emptyResponses} ({
                    responses?.length ? 
                        Math.floor(emptyResponses / responsesCount * 100) : 
                        0
                    })%
                        
            </div> */}

            <div className="response-details-generic-examples-header">
                Examples:
            </div>

            <div className="response-details-contact-examples">
                {exampleResponses.map((example: ContactResponse, index) => {
                    return (
                        <div className="response-details-contact-example">
                            <Contact contact={example} />
                        </div>
                    )
                })}
            </div>       

        </div>
    )
}